import { useEffect } from 'react';

export const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  showCancelButton = true,
  showConfirmButton = true,
  cancelText = 'Cancelar',
  confirmText = 'Prosseguir',
  onConfirm,
  confirmDisabled = false,
  maxWidth = '600px',
}) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px',
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '24px',
          width: '100%',
          maxWidth,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          maxHeight: '90vh',
          overflowY: 'auto',
        }}
      >
        <h2
          style={{
            margin: '0 0 20px 0',
            fontSize: '20px',
            fontWeight: '600',
            color: '#1a1a1a',
          }}
        >
          {title}
        </h2>

        <div style={{ marginBottom: '24px' }}>{children}</div>

        <div
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-start',
          }}
        >
          {showCancelButton && (
            <button
              onClick={onClose}
              style={{
                padding: '10px 24px',
                border: '2px solid #d1d5db',
                borderRadius: '4px',
                backgroundColor: 'white',
                color: '#374151',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f9fafb';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
              }}
            >
              {cancelText}
            </button>
          )}

          {showConfirmButton && (
            <button
              onClick={onConfirm}
              disabled={confirmDisabled}
              style={{
                padding: '10px 24px',
                border: 'none',
                borderRadius: '4px',
                backgroundColor: confirmDisabled ? '#9ca3af' : '#047857',
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
                cursor: confirmDisabled ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                opacity: confirmDisabled ? 0.6 : 1,
              }}
              onMouseEnter={(e) => {
                if (!confirmDisabled) {
                  e.currentTarget.style.backgroundColor = '#065f46';
                }
              }}
              onMouseLeave={(e) => {
                if (!confirmDisabled) {
                  e.currentTarget.style.backgroundColor = '#047857';
                }
              }}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};